export default {
	ruMonths: [
		'января',
		'февраля',
		'марта',
		'апреля',
		'мая',
		'июня',
		'июля',
		'августа',
		'сентября',
		'октября',
		'ноября',
		'декабря',
	],
	keyCodes: {
		escape: 'Escape',
	},
};
